import { Typography, Button, Box, Container } from '@mui/material';
import { HashLink } from 'react-router-hash-link';
import React, { useEffect, useState, useRef } from 'react';
import ResponsiveAppBarAlt from './ResponsiveAppBarAlt';
import Contactform from './Contactform';
import Footer from "./Footer";
import '../App.css';

const ScrollAnimation = () => {
  const [isHeroNavVisible, setIsHeroNavVisible] = useState(true);
  const heroNavWrapperRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const screenHeight = window.innerHeight;


    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

 useEffect(() => {
         const observer = new IntersectionObserver(
             ([entry]) => {
                 setIsHeroNavVisible(entry.isIntersecting);
                 const navbar = document.querySelector(".navbar.alt");
                 if (navbar) {
                     if (!entry.isIntersecting) {
                         navbar.style.marginTop = "0px";
                     } else {
                         navbar.style.marginTop = "-100px";
                     }
                 }
             },
             { threshold: 0.01 }
    );

    if (heroNavWrapperRef.current) {
      observer.observe(heroNavWrapperRef.current);
    }

    return () => {
      if (heroNavWrapperRef.current) {
        observer.unobserve(heroNavWrapperRef.current);
      }
    };
  }, []);


  return (

    <div className="App">
<ResponsiveAppBarAlt />

<main>

  <Box className="heroWrapper subpage" id="start">

  <img src="Erbe.webp" className='herobackimg' />
    <Box className='heroWrapperLayer'></Box>
    <Container maxWidth="lg" className="containerHero" /*sx={{width: 300,backgroundColor: 'success.main',}}*/>

    </Container>

    <Box className="heroNavWrapper" ref={heroNavWrapperRef}>
      <HashLink className='navItemHero' smooth to="/#leistungen">Leistungen</HashLink>
      <HashLink className='navItemHero' smooth to="/#notare">Notare</HashLink>
      <HashLink className='navItemHero' smooth to="/team">Team</HashLink>
      <HashLink className='navItemHero' smooth to="/Blog">Blog</HashLink>
      <HashLink className='navItemHero' smooth to="#kontakt">Kontakt</HashLink>
      <HashLink className='navItemHero flex' smooth to="/en"><img src="en-flag.png" className='navFlagIcon' />EN</HashLink>
    </Box>

    {/* <div className="heroCTAWrapper">
      <Button href="#" target='_blank' variant='contained' className='mandantenCTATop'>Mandanten Login<img src='arrow-weiss.png' className='servOptItemArrow' /></Button>
    </div> */}
  </Box>


  <Box className="mainWrapper">

    <Container maxWidth="lg" className="subPageContainerThin">

      <HashLink className='breadcrumb' smooth to="/#leistungen">Leistungen</HashLink>
            <Typography variant='h1' className='subTitle'>Erben und Vererben</Typography>


      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Das Erbe regeln</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
              Wenn jemand seine Erbfolge nicht regelt, gilt automatisch die gesetzliche Erbfolge. Demnach erhalten die nächsten Verwandten des Verstorbenen dessen gesamtes Vermögen. Es spielt keine Rolle, wie das Verhältnis zwischen den Verwandten und dem Verstorbenen war. Bei verheirateten, kinderlosen Paaren erben entfernte Verwandte neben dem überlebenden Ehegatten. Bei unverheirateten Paaren erbt der überlebende Partner sogar überhaupt nichts. Zwischen mehreren Erben kommt es häufig zu Streitigkeiten, vor allem in Patchwork-Familien. Ist ein Erbe in finanziellen Schwierigkeiten oder arbeitsunfähig, wird der Staat auf das Erbe zugreifen. Aber auch in harmonischen Familien kann ein handschriftliches Testament der Eltern erhebliche Probleme auslösen, weil sich die Eltern vieler gravierender rechtlicher Folgen nicht bewusst sind und die rechtlichen Begriffe nicht zutreffend verwenden. Daher empfiehlt es sich immer, die Verteilung des Nachlasses mit einem Notar zu besprechen und ein notarielles Testament zu errichten.<br /><br />
              Befindet sich eine Immobilie im Nachlass, wird das Grundbuchamt für die Umschreibung der Immobilie auf die Erben einen Erbschein zum Nachweis der Erbfolge verlangen. Dies ist im Ergebnis meist teurer als ein notarielles Testament, zumal die Erteilung des Erbscheins oft mehrere Monate dauert und mit einem weiteren Notartermin des Erben verbunden ist. Hat der Verstorbene ein Testament beim Notar errichtet, ersetzt dieses den Erbschein. Auch aus diesem Grund bietet das notarielle Testament erhebliche Vorteile gegenüber einem handschriftlichen Testament.
            </Typography>
            {/* <Button className='btnSecondary'><HashLink smooth to="#kontakt">Testament und Erbvertrag Formular</HashLink></Button> */}
            <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Erbe ausschlagen</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
              Wenn ein Mensch verstirbt, geht dessen gesamtes Vermögen automatisch auf dessen Erben über. Die Erben übernehmen auch alle Schulden des Verstorbenen. Wollen sie das Erbe nicht antreten, müssen sie die Ausschlagung des Erbes gegenüber dem Nachlassgericht erklären. Die Ausschlagungserklärung muss ein Notar beglaubigen oder die Erben müssen zum Nachlassgericht gehen. Dafür haben sie nur sechs Wochen Zeit ab dem Zeitpunkt, zu dem sie von dem Erbfall erfahren. Daher muss jeder Ausschlagende zeitnah einen Termin beim Notar oder Nachlassgericht vereinbaren.
            </Typography>
            {/* <Button className='btnSecondary'><HashLink smooth to="#kontakt">Ausschlagung Formular</HashLink></Button> */}
            <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Erbschein beantragen</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
              Im Grundsatz kann ein Erbe sein Erbrecht durch Vorlage eines handschriftlichen Testaments des Verstorbenen nachweisen. Gibt es kein handschriftliches Testament, muss er sein Erbrecht durch Urkunden vom Standesamt über das Verwandtschaftsverhältnis mit dem Erblasser nachweisen. Vererbte der Verstorbene aber u.a. eine Immobilie, wird das Grundbuchamt für die Umschreibung des Eigentums auf den oder die Erben zwingend die Vorlage eines Erbscheins verlangen. Wollen die Erben die geerbte Immobilie verkaufen, müssen sie daher einen Erbschein vorlegen. Der Erbschein ist eine besondere Urkunde, die das Nachlassgericht ausstellt. Sie weist die Erbfolge offiziell nach. Der oder die Erben können entweder beim Nachlassgericht oder bei einem Notar beantragen, einen Erbschein zu erteilen.
            </Typography>
            {/* <Button className='btnSecondary'><HashLink smooth to="https://dialog.ht-notare.de/inherit">Erbschein Formular</HashLink></Button> */}
            <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

      <Box className="intendTextWrapper">
        <Typography variant='h2' className='sectionTitle'>Erbe unter Miterben aufteilen</Typography>
        <Box className="textintendInnerWrapper margin">
        <Typography variant='body1' className='sectionText'>
              Haben mehrere Personen den Verstorbenen beerbt, entsteht eine sog. Erbengemeinschaft. Die Miterben sind gemeinsam an allen Gegenständen des Verstorbenen beteiligt. Keiner von ihnen kann allein über einen Gegenstand verfügen. Vielmehr müssen sie einstimmig beschließen, wie sie mit dem Nachlass verfahren wollen. Soll einer von ihnen Alleineigentümer eines Gegenstands werden, müssen sich die Miterben darüber auseinandersetzen. Bei Immobilien und häufig auch bei Unternehmen muss ein Notar die Auseinandersetzung beurkunden. Häufig erwirbt ein Miterbe das Alleineigentum an der Nachlassimmobilie und zahlt die anderen Miterben aus. Der Notar ermittelt zusammen mit den Beteiligten, wie eine gerechte Aufteilung des Nachlasses aussehen könnte, beurkundet die Auseinandersetzung und wickelt den Auseinandersetzungsvertrag ab.
            </Typography>
            {/* <Button className='btnSecondary'><HashLink smooth to="#kontakt">Erbauseinandersetzung Formular</HashLink></Button> */}
            <Button className='btnSecondary'><HashLink smooth to="#kontakt">Kontaktformular</HashLink></Button>
        </Box>
      </Box>

    </Container>


      

                     <Box className="map" id="map">
                                                     <Box className="contactMap">
                     
                                                         {/* <iframe width="100%" height="100%" frameBorder="0" allowFullScreen allow="geolocation" src="//umap.openstreetmap.de/en/map/notare-harbecke-thelen_85729?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=false&tilelayersControl=null&embedControl=false&datalayersControl=null&onLoadPanel=none&captionBar=false&captionMenus=false&captionControl=null&locateControl=null&measureControl=null"></iframe> */}
                     
                                                         <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank" class="contactMapLink">
                                                             <img src="Karte-HT.webp" className="contactMapImg" />
                                                             <a href="http://openstreetmap.org/copyright" target="_blank" className="mapSource">©OpenStreetMap</a>
                                                         </a>
                                                         <Container maxWidth="lg" className="container">
                                                             <Typography variant='body1' paragraph className="contactMapAddress">
                                                                 Wenn Sie auf den Link klicken, verlassen Sie unsere Webseite und werden auf Google Maps (ein Service der Google Ireland Limited Gordon House, Barrow Street Dublin 4, Irland) weitergeleitet. Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung erhalten Sie in den Datenschutzerklärungen von <a href="http://www.google.de/intl/de/policies/privacy" target="_blank">Google</a>.
                                                             </Typography>
                                                         </Container>
                                                         
                                                     </Box>
                                                     {/* <Container maxWidth="lg" id="routelink">
                                                         <Typography variant='body1' paragraph className="contactMapRouteLink">Einen Routenplaner finden sie <a href="https://maps.app.goo.gl/BiTJESJc6NsTJLce6" target="_blank">hier</a>.</Typography>
                                                     </Container> */}
                     
                                                 </Box>


                      <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. Im Parkzentrum Holzgasse (Scheerengasse 5, 53721 Siegburg) können Sie die mit „HT Notare“ markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Tiefgarage rechts abbiegen und dann in dieser Richtung bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie durch eine eigene Tür mit Klingelschild in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>



  </Box>

</main >
<Footer />
    </div >
  );
};

export default ScrollAnimation;